import { useFormikContext } from "formik";
import { useCallback, useMemo } from "react";
import { Treatment } from "../../queries/models/treatment.model";

export function HorseTreatmentsSection({
  horses,
}: {
  horses: { label: string; value: number }[];
}) {
  const { values, setFieldValue } = useFormikContext<Treatment>();

  const horseTreatments = useMemo(
    () => values.horseTreatments ?? [],
    [values.horseTreatments]
  );

  const selectedHorseIds = useMemo(
    () => horseTreatments.map((ht) => ht.horseId),
    [horseTreatments]
  );

  const horseCommentsMap = useMemo(() => {
    const map = new Map<number, string>();
    horseTreatments.forEach((ht) => {
      map.set(ht.horseId, ht.comment ?? "");
    });
    return map;
  }, [horseTreatments]);

  const handleToggleHorse = useCallback(
    (checked: boolean, horseId: number) => {
      const updated = checked
        ? [...horseTreatments, { horseId, comment: "" }]
        : horseTreatments.filter((ht) => ht.horseId !== horseId);
      setFieldValue("horseTreatments", updated);
    },
    [horseTreatments, setFieldValue]
  );

  const handleCommentChange = useCallback(
    (horseId: number, comment: string) => {
      const updated = horseTreatments.map((ht) =>
        ht.horseId === horseId ? { ...ht, comment } : ht
      );
      setFieldValue("horseTreatments", updated);
    },
    [horseTreatments, setFieldValue]
  );

  return (
    <div className="grid">
      {horses.map((horse) => {
        const selected = selectedHorseIds.includes(horse.value);
        const currentComment = horseCommentsMap.get(horse.value) ?? "";
        const checkboxId = `horse-checkbox-${horse.value}`;

        return (
          <div
            key={`horse-${horse.value}`}
            className="col-12 mb-2 py-2 border-left-1 border-gray-300 shadow-1"
          >
            <div
              className="flex align-items-center gap-2"
              onClick={() => handleToggleHorse(!selected, horse.value)}
            >
              <input
                type="checkbox"
                id={checkboxId}
                checked={selected}
                onChange={() => {}}
              />
              <label
                htmlFor={checkboxId}
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                {horse.label}
              </label>
            </div>

            {selected && (
              <div className="mt-2">
                <input
                  type="text"
                  value={currentComment}
                  onChange={(e) =>
                    handleCommentChange(horse.value, e.target.value)
                  }
                  className="p-inputtext p-component w-full"
                  placeholder={`Komentarz do ${horse.label}`}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
